<template>
  <v-slide-group v-model="selected_bar" show-arrow class="reservations-cards">
    <template v-slot:prev>
      <v-btn icon color="primary">
        <v-icon>arrow_back_ios</v-icon>
      </v-btn>
    </template>
    <template v-slot:next>
      <v-btn icon color="primary">
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>
    </template>
    <v-slide-item :value="card" class="card-container" v-for="card in Object.keys(real_total_stats)" :key="card">
      <template v-if="card != 'Unknown'">
        <v-card v-ripple="{ class: 'primary--text' }" flat color="#EEF3F9" @click="toggleGraphBars(card)"
                :class="[selected_bar === card ? 'active-bar' : '']">
          <v-icon :class="card">$rectangle</v-icon>
          <span class="card-name">{{card}}</span> <br/>
          <span class="card-value">
                <animated-integer :value="real_total_stats[card] ? real_total_stats[card] : 0"
                                  v-if="real_total_stats[card] !== undefined"></animated-integer>
                  <v-progress-circular size="20" width="2" v-else
                                       indeterminate
                                       color="primary"
                  ></v-progress-circular>
              </span>
        </v-card>
      </template>
    </v-slide-item>
  </v-slide-group>
</template>

<script>
  import AnimatedInteger from "./AnimatedInteger";

  export default {
    name: "ReservationsCards",
    components: {AnimatedInteger},
    props: ['total_stats', 'adjusted_active'],
    methods: {
      toggleGraphBars(bar) {
        this.$emit('highlight_bar', bar)
        this.selected_bar = bar
      }
    },
    data: () => ({
      selected_bar: 'Total'
    }),
    computed: {
      real_total_stats() {
        if (this.adjusted_active !== undefined) {
          return {
            'Total': this.total_stats['Total'],
            'Expired': this.total_stats['Expired'] + this.total_stats['Unknown'] - (this.adjusted_active ? Object.values(this.adjusted_active).reduce((accum, item) => accum + item, 0) : 0),
            'Completed': this.total_stats['Completed'],
            'Active': this.total_stats['Active'] + (this.adjusted_active ? Object.values(this.adjusted_active).reduce((accum, item) => accum + item, 0): 0),
            'Cancelled': this.total_stats['Cancelled'],
          }
        } else {
          return {
            'Total': this.total_stats['Total'],
            'Expired': this.total_stats['Expired'],
            'Completed': this.total_stats['Completed'],
            'Active': this.total_stats['Active'] + this.total_stats['Unknown'],
            'Cancelled': this.total_stats['Cancelled'],
          }
        }
      },
      smAndUp() {
        return this.$vuetify.breakpoint.smAndUp
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';

  .reservations-cards {
    place-content: center;
    justify-items: center;
    padding: 4rem 0;
    @media #{map-get($display-breakpoints, 'lg-and-down')} {
      padding: 4rem 0rem;

    }

    .v-icon {
      &.Total {
        display: none;
      }

      &.Active {
        fill: #76CD79
      }

      &.Completed {
        fill: var(--v-primary-base)
      }

      &.Cancelled {
        fill: #96AAC4;
      }

      &.Expired {
        fill: #fe6868;
      }
    }

    .v-card {
      border-radius: 14px !important;
      padding: 12px;
      margin: 0 .5rem;
      text-align: -webkit-center;
      min-width: 152px;
      height: 86px;
      color: white;
      font-weight: 500;
       border: 2px solid transparent!important;

      &.active-bar {
        transition: .3s;
        border: 2px solid var(--v-primary-base)!important;
      }

      .card-name {
        color: var(--v-primary-base);
        font-size: 16px;
      }

      .card-value {
        color: var(--v-primary-base);
        font-size: 27px;
      }


    }
  }

</style>



// WEBPACK FOOTER //
// src/Elements/ReservationsCards.vue